import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackCategoryInNavClicked = () => useTrackConversion({ goal: KameleoonGoalData.CategoryInNavClicked });
